<template>
    <AlternateRegistrationForm v-bind="props" />
</template>

<script>
import {
    resolveEditorParentRequiredData,
    resolveParentProps,
    resolveParentPropValues,
} from '../../utils/data-conversions';
import AlternateRegistrationForm from './AlternateRegistrationForm';

let prefixKeys = ['salesChannel'];

export default {
    name: 'ParentAlternateRegistrationForm',
    components: { AlternateRegistrationForm },
    __editor: resolveEditorParentRequiredData(AlternateRegistrationForm.__editor, prefixKeys),
    props: resolveParentProps(AlternateRegistrationForm.props, prefixKeys),
    computed: {
        props() {
            return {
                ...resolveParentPropValues(this, AlternateRegistrationForm.props, prefixKeys),
                onBehalfOf: 'parent',
            };
        },
    },
};
</script>
